import { FC, ReactNode } from 'react';
import * as S from './styled';

interface IButtonProps {
  variant: 'contained' | 'outlined';
  text: string;
  disabled?: boolean;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit';
  style?: any;
  className?: string;
}

const Button: FC<IButtonProps> = ({
  variant,
  text,
  startIcon,
  endIcon,
  type,
  className = '',
  ...rest
}) => {
  return (
    <S.CustomButton
      variant={variant}
      startIcon={startIcon || null}
      endIcon={endIcon || null}
      type={type || 'button'}
      className={className}
      {...rest}
    >
      {text}
    </S.CustomButton>
  );
};

export default Button;
